module.exports = __webpack_public_path__ + "40c2ee7f6d11fff95bb4ac3a6a9c9f96.svg";